<template>
    <div class="titlelayoutGeneric" :class="{ 'has-margin': hasMargin }">
        <h3>{{ title }}</h3>
        <small>{{ subtitle }}</small>
    </div>
</template>

<script>
export default {
    name: 'TitlePage',
    props: {
        title: {
            type: String,
            required: true,
        },
        subtitle: {
            type: String,
            required: true,
        },
        hasMargin: {
            type: Boolean,
            default: true,
        },
    },
};
</script>

<style scoped>
.titlelayoutGeneric {
    text-align: left;
    padding-bottom: 10px;
}

.titlelayoutGeneric.has-margin {
    margin: 20px;
}
@media (max-width: 768px) {
    .titlelayoutGeneric.has-margin {
        margin: 0;   
    }
}
</style>